import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import styled from 'styled-components';
import logo from '../assets/rugged-logo.png';

const HeaderContainer = styled.header`
  background-color: var(--light-color);
  border-bottom: 1px solid var(--text-color);
  padding: 1rem 0;
`;

const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  padding-left: 2rem;
`;

const Logo = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.5rem;
  font-weight: bold;
  color: var(--text-color);
  text-decoration: none;
  font-family: 'Montserrat', sans-serif;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  transition: all 0.2s;

  img {
    height: 2.5rem;
    width: auto;
  }

  &:hover {
    text-decoration: none;
    color: #666666;
  }
`;

const Nav = styled.nav`
  display: flex;
  gap: 2rem;
  align-items: center;
`;

const NavLink = styled(Link)`
  color: var(--text-color);
  text-decoration: none;
  font-weight: 500;
  transition: all 0.2s;

  &:hover {
    text-decoration: none;
    color: #666666;
  }
`;

const AuthButton = styled.button`
  background: none;
  border: 1px solid var(--text-color);
  color: var(--text-color);
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;

  &:hover {
    background-color: var(--text-color);
    color: var(--light-color);
  }
`;

const Header = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Failed to log out:', error);
    }
  };

  return (
    <HeaderContainer>
      <HeaderContent>
        <Logo to="/">
          <img src={logo} alt="BehindScams Logo" />
          BehindScams
        </Logo>
        <Nav>
          <NavLink to="/">Home</NavLink>
          <NavLink to="/blog">Blog</NavLink>
          <NavLink to="/about">About</NavLink>
          {currentUser && (
            <>
              <NavLink to="/admin">Dashboard</NavLink>
              <AuthButton onClick={handleLogout}>Logout</AuthButton>
            </>
          )}
        </Nav>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default Header; 